import { render, staticRenderFns } from "./NovaInfoModal.vue?vue&type=template&id=930b247c&lang=pug&"
import script from "./NovaInfoModal.vue?vue&type=script&lang=js&"
export * from "./NovaInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./NovaInfoModal.vue?vue&type=style&index=0&id=930b247c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports